import { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Element } from '@src/mixins/element/element'

import { Mixins } from 'vue-mixin-decorator'

import { stopPropagation } from '@src/util/functions'

import './time-picker.sass'

@Component
export class TimePicker extends Mixins<Element>(Element) {

  @Prop({ required: false })
  valueHours: string

  @Prop({ required: false })
  valueMinutes: string

  @Prop({ required: false })
  description: string

  @Prop({ required: false })
  maxValueHours: number

  @Prop({ required: false })
  maxValueMinutes: number

  @Prop({ required: false })
  minValueHours: number

  @Prop({ required: false })
  minValueMinutes: number

  @Prop({ required: false })
  changeHours: (value: string) => void

  @Prop({ required: false })
  changeMinutes: (value: string) => void

  @Prop({ required: false })
  keyupHours: (value: string) => void

  @Prop({ required: false })
  keyupMinutes: (value: string) => void

  hasFocus: boolean = false

  ctrlPressed: boolean = false

  shiftPressed: boolean = false

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.inputStyles
    ]

    return (
      this.renderElement(h, styleClasses, this.disabled, [
        this.renderInput(h, this.disabled)
      ])
    )
  }

  protected get inputStyles () {
    let styleClasses = ['input', 'time-picker']

    if (this.hasFocus) {
      styleClasses.push('focus')
    }
    return styleClasses
  }

  protected onFocus (event: FocusEvent) {
    this.hasFocus = (event.target === document.activeElement)
  }

  protected mounted () {
    if (this.valueHours) {
      this.changeMinutes(this.addZeroToHoursIfSingleNumberCharacter(this.valueMinutes))

    }
    if (this.valueMinutes) {
      this.changeHours(this.addZeroToHoursIfSingleNumberCharacter(this.valueHours))
    }
  }

  protected renderInput (h: CreateElement, disabled: boolean) {
    return <div class='time-picker-container'>
      {/* TODO replace description with label (Caption component)*/}
      {this.description ? <span class='input-description'>{this.description}</span> : ''}
      <input ref='input' maxlength='2' type='text' value={this.valueHours} placeholder={this.$t('UNITS.HH')}
             disabled={disabled} onFocus={this.onFocus} onBlur={this.onFocus} onKeyup={this.onKeyupHours}
             onInput={this.onInputChangeHours}
             onChange={this.onChangeHours}
             onClick={this.select}
             onKeydown={this.onKeydown} min={this.minValueHours} max={this.maxValueHours} />
      :
      <input ref='input' maxlength='2' type='text' value={this.valueMinutes} placeholder={this.$t('UNITS.MM')}
             disabled={disabled} onFocus={this.onFocus} onBlur={this.onFocus} onKeyup={this.onKeyupMinutes}
             onInput={this.onInputChangeMinutes}
             onChange={this.onChangeMinutes}
             onClick={this.select}
             onKeydown={this.onKeydown} min={this.minValueMinutes} max={this.maxValueMinutes} />
    </div>
  }

  protected addZeroToHoursIfSingleNumberCharacter (value) {
    if (value && value.length === 1) {
      return '0' + value
    }
    return value
  }

  protected removeZeroBeforeFirstTwoCharacters (value) {
    if (value && value.length === 3 && value[0] === '0') {
      return value.substring(1)
    }
    return value
  }

  protected replaceWithMaxValueIfGreater (value, maxValue) {
    if (maxValue && (parseInt(value, 10) > maxValue)) {
      return maxValue.toString()
    }
    return value
  }

  protected replaceWithMinValueIfSmaller (value, minValue) {
    if (minValue && (parseInt(value, 10) < minValue)) {
      return minValue.toString()
    }
    return value
  }

  protected onInputChangeHours ($event) {
    if (this.changeHours) {
      let hours = $event.target.value
      hours = this.removeZeroBeforeFirstTwoCharacters(hours)
      hours = this.replaceWithMaxValueIfGreater(hours, this.maxValueHours)
      hours = this.replaceWithMinValueIfSmaller(hours, this.minValueHours)
      this.changeHours(hours)
    }
  }

  protected onInputChangeMinutes ($event) {
    if (this.changeMinutes) {
      let minutes = $event.target.value
      minutes = this.removeZeroBeforeFirstTwoCharacters(minutes)
      minutes = this.replaceWithMaxValueIfGreater(minutes, this.maxValueMinutes)
      minutes = this.replaceWithMinValueIfSmaller(minutes, this.minValueMinutes)
      this.changeMinutes(minutes)
    }
  }

  protected onChangeHours ($event) {
    if (this.changeHours) {
      let hours = $event.target.value
      hours = this.addZeroToHoursIfSingleNumberCharacter(hours)
      this.changeHours(hours)
    }
  }

  protected onChangeMinutes ($event) {
    if (this.changeMinutes) {
      let minutes = $event.target.value
      minutes = this.addZeroToHoursIfSingleNumberCharacter(minutes)
      this.changeMinutes(minutes)
    }
  }

  protected onKeydown ($event) {
    this.removeNonNumericCharacters($event)
  }

  protected removeNonNumericCharacters ($event) {
    // ctrl on windows or command on macbook
    if ($event.keyCode === 17 || $event.keyCode === 91) {
      this.ctrlPressed = true
      return
    }
    if ($event.keyCode === 16) {
      this.shiftPressed = true
      return
    }
    let ok = false
    // if introduced symbol is : a c v x when ctrl is pressed
    if (this.ctrlPressed === true && ($event.keyCode === 65 || $event.keyCode === 67 || $event.keyCode === 86 || $event.keyCode === 88)) {
      ok = true
    }
    // if introduced symbol is  one of the following:
    if (($event.keyCode >= 48 && $event.keyCode <= 57) // 0-9 interval
      || ($event.keyCode >= 96 && $event.keyCode <= 105) // 0-9 interval numpad
      || $event.keyCode === 8 // backspace
      || $event.keyCode === 9 // tab
      || $event.keyCode === 13 // enter
      || $event.keyCode === 37 // left arrow
      || $event.keyCode === 38 // top arrow
      || $event.keyCode === 39 // right arrow
      || $event.keyCode === 40) { // bottom arrow
      ok = true
    }
    if (!ok || this.shiftPressed) {
      // stop event propagation
      stopPropagation($event)
    }
  }

  protected onKeyupHours ($event) {
    if ($event.keyCode === 17 || $event.keyCode === 91) {
      this.ctrlPressed = false
    }
    if ($event.keyCode === 16) {
      this.shiftPressed = false
      return
    }
    if (this.keyupHours) {
      this.keyupHours($event.target.value)
    }
  }

  protected onKeyupMinutes ($event) {
    if ($event.keyCode === 17 || $event.keyCode === 91) {
      this.ctrlPressed = false
    }
    if ($event.keyCode === 16) {
      this.shiftPressed = false
      return
    }
    if (this.keyupMinutes) {
      this.keyupMinutes($event.target.value)
    }
  }

  private select ($event) {
    $event.target.select()
  }
}
